<template>
  <div>
    <div
      class="column-left purple-black-gradient-background hero is-fullheight"
    >
      <img
        src="../../assets/img/logos-empower/logo-empower-branco.png"
        alt=""
      />

      <p class="has-text-centered left-text">
        <span class="title is-1 is-size-3-mobile is-spaced has-text-white">
          AS EMPRESAS DOS SEUS SONHOS<br v-if="isDesktop" />
          EM UM SÓ LUGAR
        </span>

        <br />
        <br />

        <span class="subtitle is-4 is-size-5-mobile has-text-white">
          Capacitações, networking e vagas. 100% gratuito!
        </span>
      </p>

      <router-view v-if="!isDesktop" />
    </div>

    <div class="column-right hero is-fullheight" v-if="isDesktop">
      <a href="https://empower.vision">
        <p>
          <span style="position: relative; bottom: 6px;">
            Voltar para site
          </span>
          <b-icon icon="arrow-alt-circle-right"></b-icon>
        </p>
      </a>
      <router-view v-if="isDesktop" />
    </div>
    <whats-app />
  </div>
</template>

<script>
import { responsive } from "../../mixins/responsive";
import WhatsApp from "../../components/commom/WhatsApp";

export default {
  mixins: [responsive],

  components: {
    WhatsApp
  },

  mounted() {
    document.querySelector("body").classList.remove("has-navbar-fixed-top");
  }
};
</script>

<style scoped>
.left-text {
  max-width: 880px;
  padding: 15vh 3rem 0;
  margin-left: auto;
  margin-right: auto;
}
@media (max-width: 768px) {
  .left-text {
    max-width: 660px;
  }
}
@media (max-width: 540px) {
  .left-text {
    max-width: 90%;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 1023px) {
  .column-left {
    width: 50%;
    overflow: hidden;
    float: left;
  }
  .left-text {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
}
.column-right {
  width: 50%;
  overflow: hidden;
  float: right;
}
img {
  position: absolute;
  top: 30px;
  left: 30px;
  max-width: 200px;
}
a {
  position: absolute;
  top: 30px;
  right: 30px;
  color: black;
}
</style>
